import { useWorkspaceInfoAiUser } from '@modules/workspace/providers/WorkspaceInfo/hooks/useWorkspaceInfoAiUser';
import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { useWorkspaceParticipantsAsUsers } from 'src/hooks/useWorkspace';
import { useSelector } from 'src/redux/store';

export const useMentionableParticipants = (
  conversationId: string,
  parentId?: string,
  withAi = true,
) => {
  const { aiUser: coperaUser } = useWorkspaceInfoAiUser();

  const conversationInStore = useSelector(
    (state) => state.chat.conversations.byId[parentId || conversationId],
    shallowEqual,
  );

  const parentConversationInStore = useSelector(
    (state) => (parentId ? state.chat.conversations.byId[parentId] : null),
    shallowEqual,
  );

  const conversation = useMemo(() => {
    if (parentId) {
      return (
        conversationInStore?.subchannels?.find(
          (item) => item._id === conversationId,
        ) || conversationInStore
      );
    }
    return conversationInStore;
  }, [conversationInStore, conversationId, parentId]);

  const participants = parentConversationInStore
    ? parentConversationInStore?.participants || []
    : conversation?.participants || [];

  const participantsWithAi = [
    ...participants,
    ...(coperaUser ? [{ user: coperaUser._id }] : []),
  ];

  const mentionableParticipants =
    useWorkspaceParticipantsAsUsers(
      withAi ? participantsWithAi : participants,
    ) || [];

  return {
    conversation,
    mentionableParticipants,
  };
};
